import {REPORT_NEW_FRONTLINE_COACHES} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_FRONTLINE_COACHES,
};
